import type { ChakraComponent } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import React from 'react';

export const SelectIcon: ChakraComponent<'svg', any> = (props) => (
    <chakra.svg
        width={'10px !important'}
        viewBox={'0 0 10 5'}
        fill={'none'}
        {...props}
    >
        <path d={'M0 0L5 5L10 0H0Z'} fill={'#5C6C7F'} />
    </chakra.svg>
);
